module.exports = __webpack_public_path__ + "img/52.ebbd0728.jpg";